import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  Box,
  Text,
  Flex,
} from '@chakra-ui/react';
import EquipmentList from './EquipmentList';

const SelectedItemsModal = ({ 
  isOpen, 
  onClose, 
  fixedItems, 
  currentEquipmentConfig, 
  handlePreferenceChange, 
  handleItemSelect, 
  loadItemsAndPreferences, 
  preferences, 
  fetchUserEquipments, 
  targetUserId, 
  currentUser, 
  isTsubo, 
  loading, 
  fixedTotalPrice 
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>見積アイテム</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack align="stretch" spacing={6}>
            {fixedItems.length === 0 && (
              <Box w="100%" p={4} bg="gray.50" borderRadius="lg" borderWidth="1px" borderColor="gray.200">
                <Text fontSize="lg" fontWeight="bold" color="gray.700">
                  選択中のアイテムはありません
                </Text>
              </Box>
            )}
            {/* 仮確定中のアイテム（複数対応） */}
            {fixedItems.length > 0 && (
              <Box w="100%" p={4} bg="gray.50" borderRadius="lg" borderWidth="1px" borderColor="gray.200">
                <Flex align="center" mb={4}>
                  <Text fontSize="lg" fontWeight="bold" color="gray.700">
                    合計: ¥{fixedTotalPrice.toLocaleString()}
                  </Text>
                </Flex>
                {loading ? (
                  <Flex align="center" justify="center" minH="200px">
                    <Text fontSize="lg" color="gray.500">概算見積アイテムを読み込み中...</Text>
                  </Flex>
                ) : (
                  <EquipmentList
                    items={fixedItems}
                    config={currentEquipmentConfig}
                    onPreferenceChange={handlePreferenceChange}
                    onItemSelect={handleItemSelect}
                    isFixedList
                    onReloadPreferences={loadItemsAndPreferences}
                    onReloadMaterialFiles={loadItemsAndPreferences}
                    user_item_preferences={preferences}
                    onReloadUserEquipments={fetchUserEquipments}
                    targetUserId={targetUserId || currentUser.uid}
                    isTsubo={isTsubo}
                  />
                )}
              </Box>
            )}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SelectedItemsModal;
